import { BaseOrganizationEndpoints } from './base';
import type { NotificationsGetResponse } from '../types/notifications';

export class Notifications extends BaseOrganizationEndpoints {
  async getNotifications() {
    return this.requestWithStatus<NotificationsGetResponse>(
      'GET',
      '/v1/notifications'
    );
  }
}
